import { render } from "./CustomerSalesHistory.vue?vue&type=template&id=adf13d8a&scoped=true"
import script from "./CustomerSalesHistory.vue?vue&type=script&lang=js"
export * from "./CustomerSalesHistory.vue?vue&type=script&lang=js"

import "./CustomerSalesHistory.vue?vue&type=style&index=0&id=adf13d8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf13d8a"]])

export default __exports__